/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React, { useEffect, useState } from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import BannerCarousel from "../components/BannerCarousel";
import ReactPlayer from "react-player/lazy";
import HTMLReactParser from "html-react-parser";
import axios from "axios";
import vaneesaimg from "./Images/Vanessa-Torres.png";
import pavanimg from "./Images/pavan-agarwal.png";
import topbg from "./Images/top-bg.png";
import rightbg from "./Images/right-bg.png";
import Vector from "./Images/Vector.png";
import Vector1 from "./Images/Vector1.png";

export default function Header() {
  const [buffyEpisodeJSONObject, setBuffyEpisodeJSONObject] = useState();
  const [eventHeading, setEventHeading] = useState("");

  // useEffect(() => {
  //   //get buffy the rate slayer episode details
  //   axios
  //     .get(process.env.REACT_APP_BUFFY_LATEST_EPISODE_JSON, {
  //       headers: { 'Content-Type': 'application/json' },
  //     })
  //     .then((response) => {
  //       let buffyEpisodeJson = response.data;
  //       let buffyEventJson;
  //       setBuffyEpisodeJSONObject(buffyEpisodeJson);
  //       //get buffy the rate slayer event details
  //       axios
  //       .get(process.env.REACT_APP_BUFFY_EVENT_HEADING_JSON, {
  //         headers: { 'Content-Type': 'application/json' },
  //       })
  //       .then((response) => {
  //         if (response.data) {
  //           buffyEventJson = response.data;
  //         }

  //         const defaultHeading = "<h2>Here's your fuel for better decisions!</h2>";
  //         let dynamicHeading = defaultHeading;

  //         if (buffyEpisodeJson.eventHeading) {
  //           dynamicHeading = buffyEpisodeJson.eventHeading;
  //         } else if (buffyEventJson.eventHeading) {
  //           dynamicHeading = buffyEventJson.eventHeading;
  //         }

  //         if (dynamicHeading) {
  //           setEventHeading(HTMLReactParser(dynamicHeading));
  //         }
  //       });

  //       return response;
  //     });
  // }, []);

  return (
    <>
      <Container fluid id="header-wrapper">
        <img src={topbg} className="bg-image1" />
        <img src={rightbg} className="bg-image2" />
        {/* <Row className="justify-content-center wrapper">
        <Col xs={8} md={5} lg={4} className="mt-3">
          
          <a href="https://www.swmc.com" target="_blank" rel="noreferrer">
            <Image
              src="https://resources.swmc.com/swmc-images/sunwest-trust-white-logo.png"
              fluid
              alt="Sun West Mortgage Logo"
              className="sunwestlogo"
            />
          </a> 
          
        </Col>
      </Row> */}

        <Row className="justify-content-center ">
          <Col md={3} lg={3} xl={3} className="images-">
            <div className="image-box">
              <img src={Vector1} className="bg-image4 " />
              <img src={vaneesaimg} className="img-fluid w-50 vaneesa-img" />
              <p className="imagetext1 imagetext text-center">Vanessa Torres</p>
            </div>
          </Col>
          <Col md={6} lg={6} xl={6}>
            <div className="text-center">
              <h5 className="break">
                “I’m Closing A Loan A Day At Sun West, And <br></br> I Spend
                More Time With My Family.”<br></br>-Vanessa Torres
              </h5>

              <div className="freedom-text">
                <p className="freedom ">
                  Watch Vanessa’s Conversation with Pavan Agarwal,<br></br> CEO
                  of Sun West Mortgage.
                </p>
                <p className="freedom">
                  Learn her success tips for all Loan Originators.{" "}
                </p>
              </div>
            </div>
          </Col>
          <Col md={3} lg={3} xl={3} className="images-">
            <img src={Vector} className="bg-image3" />
            <img src={pavanimg} className="img-fluid  w-50 pawan-img" />
            <p className="imagetext2  imagetext text-center ">Pavan Agarwal</p>
          </Col>
        </Row>
        <Row>
          <Col xl={12} lg={12}>
            <BannerCarousel />
          </Col>
        </Row>
      </Container>
      <Container fluid id="header-wrapper1">
        {/* <Row className="justify-content-center">
    <Col xs={8} md={5} lg={4} className="mt-3">
          
          <a href="https://www.swmc.com" target="_blank" rel="noreferrer">
            <Image
              src="https://resources.swmc.com/swmc-images/sunwest-trust-white-logo.png"
              fluid
              alt="Sun West Mortgage Logo"
              className="sunwestlogo"
            />
          </a> 
          
        </Col>
        
      </Row> */}
        <Row>
          <Col lg={6} xl={6}>
            <div className="text-center">
              <h5 className="break">
                “I’m Closing A Loan A Day <br></br> At Sun West, And I Spend{" "}
                <br></br> More Time With My Family.”<br></br>-Vanessa Torres
              </h5>

              <div className="freedom-text">
                <p className="freedom ">
                  Watch Vanessa’s Conversation with <br></br> Pavan Agarwal, CEO
                  of <br></br>Sun West Mortgage.
                </p>
                <p className="freedom">
                  Learn her success tips for all <br></br>Loan Originators.{" "}
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={6} sm={6}>
            <div>
              <img src={vaneesaimg} className="img-fluid w-50 vaneesa-img1" />
              <p className="imagetext1 imagetext text-center">Vanessa Torres</p>
            </div>
          </Col>
          <Col xs={6} sm={6} className=" ">
            <div>
              <img src={pavanimg} className="img-fluid w-50  pawan-img1" />
              <p className="imagetext2  imagetext text-center ">
                Pavan Agarwal
              </p>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xl={12} lg={12}>
            <BannerCarousel />
          </Col>
        </Row>
      </Container>
    </>
  );
}
